import { clsx } from 'clsx';
import { Link } from 'react-router';

import { Button } from '@/components/shared/Button';

import cn from './styles.module.sass';

export const UnderDev = ({ classname }: { classname?: string }) => {
    return (
        <div className={clsx(cn.container, classname)}>
            <div className={cn.imgWrapper}>
                <img src="/images/icons/under_development.svg" alt="" />
            </div>
            <p className={cn.description}>Раздел в разработке</p>
            <Link to="/">
                <Button className={cn.button}>Вернуться на главную</Button>
            </Link>
        </div>
    );
};
